import axios from "axios";
import { defaultConfig } from "./config/DefaultConfig";
import { defaultServerConfig } from "./config/DefaultServerConfig";
import { UnexpectedAPIError } from "./errors";
import { validateConfig, fullUrl } from "./utils/config.utils";
import { handleAxiosError } from "./utils/error.utils";
export const config = (() => {
    const _config = defaultConfig;
    const _cachedServerconfig = defaultServerConfig;
    function set(config) {
        const validatedConfig = validateConfig(config);
        // persist config in closure variable
        Object.keys(validatedConfig).forEach((value, key) => {
            _config[value] = validatedConfig[value];
        });
    }
    function get() {
        return _config;
    }
    async function readServerConfig(token) {
        if (_cachedServerconfig.version !== "default") {
            return _cachedServerconfig;
        }
        try {
            const requestConfig = token
                ? {
                    headers: { Authorization: `Bearer ${token}` },
                }
                : undefined;
            const url = `${fullUrl(_config)}/config`;
            const response = await axios.get(url, requestConfig);
            if (response.status === 200) {
                const copyObject = { ...response.data };
                Object.keys(copyObject).forEach((value, key) => {
                    if (value !== "metadata_configuration") {
                        _cachedServerconfig[value] = copyObject[value];
                    }
                    else {
                        _cachedServerconfig[value] =
                            copyObject[value] && copyObject[value].substring(0, 1) === "["
                                ? JSON.parse(copyObject[value])
                                : [];
                    }
                });
                return _cachedServerconfig;
            }
            else if (response.status === 401) {
                // not allowed.. return default!
                return _cachedServerconfig;
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (axios.isAxiosError(error) && error.code === "401") {
                // not allowed.. return default!
                console.log("Not allowed return default", _cachedServerconfig);
                return _cachedServerconfig;
            }
            else if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function setServerConfig(config) {
        // remove ready only && toSerialize props
        const { auth_keypair_public, metadata_configuration, version, ...requestBody } = config;
        try {
            const url = `${fullUrl(_config)}/config`;
            const response = await axios.put(url, {
                ...requestBody,
                metadata_configuration: metadata_configuration
                    ? JSON.stringify(metadata_configuration)
                    : "[]",
            });
            if (response.status === 200) {
                Object.keys(requestBody).forEach((value) => {
                    _cachedServerconfig[value] = requestBody[value];
                });
                return _cachedServerconfig;
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    return {
        set: set,
        get: get,
        fullUrl: () => fullUrl(_config),
        server: readServerConfig,
        serverSet: setServerConfig,
    };
})();
